import NodeItem from './NodeItem'
import { IInputValue, ITemplate, ITemplateData } from '../../../types/templates'
import ReactPDF, { Document, Page, Text, StyleSheet, Font, View } from '@react-pdf/renderer'
import { IService } from '../../../types/services'
// import { useEffect } from 'react'
// import BlockItem from './BlockItem'
// import { createPdfElements } from '../../../utils/pdf-functions'

// Create styles
const styles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 45,
    paddingHorizontal: 35,
  },
  header: {
    fontSize: 16,
    color: 'black',
    marginBottom: 0,
    textAlign: 'right',
    fontFamily: 'OpenSans',
    fontStyle: 'bold',
  },
  subheader: {
    fontSize: 8,
    color: 'grey',
    marginBottom: 15,
    textAlign: 'right',
    fontFamily: 'OpenSans',
    fontStyle: 'bold',
  },
  footer: {
    position: 'absolute',
    fontSize: 12,
    bottom: 25,
    left: 35,
    right: 0,
    textAlign: 'center',
    color: 'grey',
    fontFamily: 'OpenSans',
    fontStyle: 'semi-bold',
  },
})

// Define fonts for the component
Font.register({
  family: 'OpenSans',
  fonts: [
    {
      src: require('../fonts/OpenSans-Regular.ttf').default,
    },
    {
      fontStyle: 'semi-bold',
      src: require('../fonts/OpenSans-SemiBold.ttf').default,
    },
    {
      fontStyle: 'bold',
      src: require('../fonts/OpenSans-Bold.ttf').default,
    },
  ],
})

// Create Document Component
export const TemplateGenerator = (
  template: ITemplate,
  inputValues: IInputValue[],
  watermark: boolean | undefined,
  service: IService | undefined
): React.ReactElement<
  ReactPDF.DocumentProps,
  string | React.JSXElementConstructor<any>
> => {
  const templateData = (template?.template_data || {
    blocks: [],
    inputs: [],
  }) as ITemplateData

  let fixHTMLCode = templateData.HTMLCode
  const matchConditionals = fixHTMLCode.match(
    /\[['1-90-9*a-zA-ZÀ-ú.,:;$)(%\s']+]{[1-90-9*]+}/g
  )

  for (let index = 0; index < inputValues.length; index++) {
    const position = Number(inputValues[index].pos)
    if (
      [
        'text',
        'email',
        'money',
        'date',
        'list',
        'number',
        'multiselect',
        'sign',
      ].includes(inputValues[index].type)
    ) {
      if (!isNaN(position)) {
        if (inputValues[index].type === 'sign') {
          fixHTMLCode = fixHTMLCode.replaceAll(
            '[' + (position + 1) + ']',
            '*sign*' + inputValues[index].value.trim()
          )
        } else {
          fixHTMLCode = fixHTMLCode.replaceAll(
            '[' + (position + 1) + ']',
            inputValues[index].value.trim()
          )
        }
      }
    }

    if (inputValues[index].type === 'select') {
      if (!isNaN(position)) {
        const findConditionalByIndex = matchConditionals?.filter(
          (conditional: string) => conditional.includes(`{${position + 1}}`)
        )

        if (findConditionalByIndex && findConditionalByIndex.length > 0) {
          for (const conditional of findConditionalByIndex) {
            const options: any = conditional
              .split('{')[0]
              .replaceAll(/[[\]]+/g, '')
              .split("',")
            const option = options[Number(inputValues[index].value)]
              .trim()
              .replaceAll("'", '')

            if (option && option.length > 0) {
              if (!isNaN(option)) {
                const inputValue = inputValues.find(
                  (i: IInputValue) => i.pos === Number(option) - 1
                )
                if (inputValue) {
                  if (inputValue.options && inputValue.conditional) {
                    const option = inputValue.options.split(',')
                    fixHTMLCode = fixHTMLCode.replaceAll(
                      conditional,
                      option[Number(inputValue.value)].trim()
                    )
                  } else {
                    let currentValue
                    if(inputValue.options) currentValue = inputValue.options.split(',')
                    fixHTMLCode = fixHTMLCode.replaceAll(
                      conditional,
                      `${currentValue ? currentValue[inputValue.value].trim() : inputValue.value.trim()}`
                    )
                  }
                } else
                  fixHTMLCode = fixHTMLCode.replaceAll(
                    conditional,
                    ' ________________'
                  )
              } else fixHTMLCode = fixHTMLCode.replaceAll(conditional, option)
            } else if (option === '')
              fixHTMLCode = fixHTMLCode.replaceAll(conditional, option)
          }
        }
        const options: any = inputValues[index].options
        fixHTMLCode = fixHTMLCode.replaceAll(
          '[' + (position + 1) + ']',
          options.split(',')[Number(inputValues[index].value)].trim()
        )
      }
    }
  }

  // console.log(inputValues)
  // console.log(matchConditionals)
  // console.log(templateData.inputs);

  for (const conditional of matchConditionals || []) {
    const options: any = conditional
      .split('{')[0]
      .replaceAll(/[[\]]+/g, '')
      .split("',")

    const inputNumber = Number(conditional.split('{')[1].replace('}', ''))
    const input = templateData.inputs[inputNumber - 1]
    const option = options[0].trim().replaceAll("'", '')

    if (input?.conditional) {
      fixHTMLCode = fixHTMLCode.replaceAll(conditional, '')
    } else {
      if (!isNaN(option))
        fixHTMLCode = fixHTMLCode.replaceAll(conditional, ' ________________')
      else
        fixHTMLCode = fixHTMLCode.replaceAll(conditional, ' ________________')
    }
  }

  fixHTMLCode = fixHTMLCode.replaceAll(
    // /(?:^|\s|[^\p{L}\d\s@#])\[([1-90-9*]+)\]/g,
    /\[([1-90-9*]+)\]/g,
    ' ________________'
  )

  // fixHTMLCode = fixHTMLCode.replaceAll(
  //   /\[['1-9a-zA-ZÀ-ú.\s,\s']+]{[1-9]+}/g,
  //   ' ________________'
  // )

  // console.log(fixHTMLCode)
  const parser = new DOMParser()
  
/*   console.log(fixHTMLCode) */

  const documentTags: any = parser
    .parseFromString(fixHTMLCode, 'text/html')
    .getElementsByTagName('body')[0].childNodes
  const PDFNodes = documentTags

  return (
    <Document
      creator={'Justiexpress'}
      producer={'Justiexpress'}
      author={'Justiexpress'}
    >
      <Page style={styles.body}>
        <View fixed>
          {watermark !== false  
          ? <>
              <Text style={styles.header}>Justiexpress</Text>
              <Text style={styles.subheader}>www.justiexpress.com</Text>
            </>  
          : <>
              <Text style={styles.header}> </Text>
              <Text style={styles.subheader}> </Text> 
            </> 
          }       
        </View>

        {/* {template?.template_data && templateData?.blocks?.length > 0 ? (
          templateData.blocks.map((block: IBlock, index: number) => (
            <BlockItem key={index} block={block} inputValues={inputValues} />
          ))
        ) : (
          <></>
        )} */}

        {PDFNodes &&
          PDFNodes?.length > 0 &&
          [...PDFNodes].map((PDFNode: any, index: number) =>
            PDFNode ? (
              <NodeItem
                key={index}
                PDFNode={PDFNode}
                inputValues={inputValues}
                service={service}
              />
            ) : (
              <Text key={index}>Invalid node</Text>
            )
          )}

        <Text
          style={styles.footer}
          render={({ pageNumber, totalPages }) =>
            `${pageNumber} / ${totalPages}`
          }
          fixed
        />
      </Page>
    </Document>
  )
}
